import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import { CheckIcon } from 'components/ReusableComponents/Icons/Check'

import styles from './ContentVariants.module.scss'

export const PublishRow = ({
  isAlreadyPublished,
  hotelsLength,
  matchPercentage,
  firstHotelName,
  onPublishClick
}) => {
  return (
    <div className={styles.publishRow}>
      <div className={styles.publishRowTextHolder}>
        <p className={styles.publishRowMainText}>
          {hotelsLength === 1 ? firstHotelName : `${hotelsLength} hotels`}
        </p>

        {isAlreadyPublished && (
          <p className={styles.publishRowPreText}>Already has the new content</p>
        )}
        {!isAlreadyPublished && matchPercentage === 100 && (
          <p className={styles.publishRowPreText}>Has the previous content</p>
        )}
        {!isAlreadyPublished && matchPercentage !== 100 && (
          <p className={styles.publishRowPreText}>
            Has a content {matchPercentage}% similar to the previous one
          </p>
        )}
      </div>
      <div className={styles.publishButtonHolder}>
        {isAlreadyPublished && (
          <div className={styles.publishedButton}>
            <CheckIcon fill="white" />
            Published
          </div>
        )}
        {!isAlreadyPublished && (
          <PrimaryRegularButton onClick={onPublishClick}>Publish</PrimaryRegularButton>
        )}
      </div>
    </div>
  )
}
